import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer from '../reducers'
import { DEFAULT_PROJECT_CENTER } from '../../../lib/const'
import {
  getMassUnits,
  getDistanceUnits,
  getSpeedUnits,
} from '../../../lib/util'

const loggerMiddleware = createLogger()

const initialUnits = {
  massUnits: getMassUnits()[0],
  distanceUnits: getDistanceUnits()[0],
  speedUnits: getSpeedUnits()[0],
}

export const initialLocalStorage = {
  projects: [
    {
      center: `{"lat":${DEFAULT_PROJECT_CENTER[1]},"lon":${DEFAULT_PROJECT_CENTER[0]}}`,
      geojson: '',
      id: '1',
      name: 'Demo Project',
      description: 'Demo Project',
      units: initialUnits,
    },
  ],
  scenarios: [
    {
      id: '1',
      project_id: '1',
      name: 'Demo Scenario',
      description: 'Demo Scenario',
    },
  ],
  selectedProjectId: null,
  selectedScenarioId: null,
  obstacles: [],
  attacks: [],
  selectedObstacle: {},
  selectedAttack: {},
  mapChoice: 'light-v9',
  remoteStorage: {
    projects: false,
    scenarios: false,
    attacks: false,
    obstacles: false,
  },
  acceptedTandC: true,
}

const updateState = state => {
  if (!state.projects[0].units) {
    // this is an old version of the state. we update it on the fly to make it compatible
    // with the current version of the application
    console.log('Updating state')
    let originalAttacks = {}
    let updatedAttacks = []
    state.attacks.forEach(attack => {
      if (!attack.original_id) {
        // this is an original attack, we need to get the project_id &
        // scenario_id for later
        originalAttacks[attack.id] = {
          project_id: attack.project_id,
          scenario_id: attack.scenario_id ? attack.scenario_id : '1',
        }
      }
    })
    state.attacks.forEach(attack => {
      let updatedAttack = {
        ...attack,
        active: true,
        units: initialUnits,
        scenario_id: attack.scenario_id ? attack.scenario_id : '1',
      }
      if (attack.original_id) {
        // this is a recalculated attack, original_id is the id of the attack it was
        // recalculated from
        updatedAttack['project_id'] =
          originalAttacks[attack.original_id].project_id
        updatedAttack['scenario_id'] =
          originalAttacks[attack.original_id].scenario_id
        let all_vehicle_data = {}
        all_vehicle_data[attack.vehicle] = {
          end_speed: attack.end_speed,
        }
        updatedAttack['all_vehicle_data'] = all_vehicle_data
      }
      updatedAttacks.push(updatedAttack)
    })
    state.attacks = updatedAttacks
    state.projects[0].units = initialUnits
  }

  return state
}

// convert object to string and store in localStorage
export function saveToLocalStorage(state) {
  console.log('saveToLocalStorage')
  try {
    const serialisedState = JSON.stringify(state)
    // eslint-disable-next-line no-undef
    localStorage.setItem('persistantState', serialisedState)
  } catch (e) {
    console.warn(e)
  }
}

// load string from localStarage and convert into an Object
// invalid output must be undefined
export function loadFromLocalStorage() {
  console.log('loadFromLocalStorage')
  try {
    // eslint-disable-next-line no-undef
    const serialisedState = localStorage.getItem('persistantState')
    if (serialisedState === null) return undefined
    let parsedState = JSON.parse(serialisedState)
    return updateState(parsedState)
  } catch (e) {
    console.warn(e)
    return undefined
  }
}

let store
if (process.env.STORAGE && process.env.STORAGE === 'remote') {
  store = createStore(
    rootReducer,
    applyMiddleware(thunkMiddleware, loggerMiddleware)
  )
} else {
  let ls = loadFromLocalStorage()

  if (ls === undefined) {
    // prepopulate a project & scenario for first time users
    ls = initialLocalStorage
  }

  store = createStore(
    rootReducer,
    ls,
    applyMiddleware(thunkMiddleware, loggerMiddleware)
  )
  // listen for store changes and use saveToLocalStorage to
  // save them to localStorage
  store.subscribe(() => saveToLocalStorage(store.getState()))
}

export default store
